module.exports = __webpack_public_path__ + "img/kangyuan.ec69a877.png";